// itExperienceAction.js
export const SET_IT_OPTION_SELECTED = 'SET_IT_OPTION_SELECTED';
export const RESET_IT_OPTION_SELECTED = 'RESET_IT_OPTION_SELECTED';
export const SET_IT_SELECTED_OPTION = 'SET_IT_SELECTED_OPTION';
export const SET_IT_EXPERIENCE_COMMENTS = 'SET_IT_EXPERIENCE_COMMENTS';

export const setOptionSelected = (isSelected) => ({
    type: SET_IT_OPTION_SELECTED,
    payload: isSelected,
});

export const resetOptionSelected = () => ({
    type: RESET_IT_OPTION_SELECTED,
});

export const setSelectedOption = (option) => ({
    type: SET_IT_SELECTED_OPTION,
    payload: option,
});

export const setComments = (comments) => ({
    type: SET_IT_EXPERIENCE_COMMENTS,
    payload: comments,
});
